module.exports = __webpack_public_path__ + "img/raw.4bd726c0.png";